import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { MedicationModel } from "../Medication/MedicationModel";

class MedicalItemMedicationAndPrescriptionTableItem implements ITableDataSourceItem<MedicationModel> {
    public Model: MedicationModel;
    public IsSelected: boolean;
    public Name: string;
    public ShowInstruction: boolean;
    public showCeased: boolean;

    constructor(item: MedicationModel) {
        this.Model = item;
        this.IsSelected = false;
        this.ShowInstruction = false;
        this.showCeased = false;
    }
}

export { MedicalItemMedicationAndPrescriptionTableItem };
